import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  DEFAULT_METRIC_CARDS_LAYOUT,
  DEFAULT_METRIC_CARDS_SELECTABLE,
  MetricCardItem,
  MetricCardsLayout,
  resolveMetricCardTone,
} from './metric-cards.types';

@Component({
  selector: 'app-metric-cards',
  templateUrl: './metric-cards.component.html',
  styleUrls: ['./metric-cards.component.scss'],
})
export class MetricCardsComponent {
  @Input() items: MetricCardItem[] = [];
  @Input() selectedId: string | null = null;
  @Input() selectable = DEFAULT_METRIC_CARDS_SELECTABLE;
  @Input() layout: MetricCardsLayout = DEFAULT_METRIC_CARDS_LAYOUT;

  @Output() cardSelected = new EventEmitter<MetricCardItem>();

  readonly resolveTone = resolveMetricCardTone;

  trackById(_: number, item: MetricCardItem): string {
    return item.id;
  }

  layoutClass(): string {
    return `metric-cards--layout-${this.layout}`;
  }

  isSelected(item: MetricCardItem): boolean {
    return this.selectedId === item.id;
  }

  onCardClick(item: MetricCardItem): void {
    if (!this.selectable) {
      return;
    }
    this.cardSelected.emit(item);
  }

  onCardKeydown(event: KeyboardEvent, item: MetricCardItem): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onCardClick(item);
    }
  }

  showDelta(item: MetricCardItem): boolean {
    return item.deltaPercent !== null && item.deltaPercent !== undefined;
  }
}
